<template>
  <v-container fill-height>
    <v-layout row wrap justify-center>
      <v-flex xs12>
        <Toolbar @back-clicked="backClick" />
      </v-flex>
      <ConfirmDialog
        :show="dialog"
        :body="msg"
        @confirm="goBack"
        @cancel="dialog = false"
      />
      <v-flex xs12 md7>
        <FlippingCard
          :confidence="confidence"
          :card="card"
          :alternative="alternative"
          v-if="loaded"
        />
        <LoadingSpinner v-else />
      </v-flex>
      <BottomButtonWithText
        text="View Alternatives"
        :to="cardPath"
        v-if="loaded"
      />
    </v-layout>
  </v-container>
</template>

<script>
import Toolbar from "../components/toolbars/Toolbar";
import LoadingSpinner from "../components/LoadingSpinner";
import FlippingCard from "../components/FlippingCard";
import ConfirmDialog from "../components/dialogs/ConfirmDialog";
import BottomButtonWithText from "../components/buttons/BottomButtonWithText";
import { db } from "../plugins/firebase";
import { deleteConfirmText } from "../message-bodies";
import router from "../router";

export default {
  components: {
    FlippingCard,
    ConfirmDialog,
    Toolbar,
    BottomButtonWithText,
    LoadingSpinner
  },
  props: ["colId", "cardId"],
  data: () => ({
    card: {},
    collection: {},
    loadedAlts: [],
    loaded: false,
    dialog: false,
    msg: deleteConfirmText
  }),
  watch: {
    sortedAlts: function() {
      this.loadedAlts = this.sortedAlts;
    }
  },
  created: function() {
    if (this.user) {
      this.bindCollection()
        .then(this.bindCard)
        .then(this.loadPage);
    }
  },
  computed: {
    user() {
      return this.$store.getters.currentUser;
    },
    cardPath: function() {
      return "/answerlist/" + this.cardId;
    },
    sortedAlts() {
      try {
        return this.card.alternatives
          .slice()
          .sort((alt1, alt2) => this.getRating(alt2) - this.getRating(alt1));
      } catch {
        return this.loadedAlts;
      }
    },
    alternative() {
      try {
        return this.sortedAlts[0];
      } catch {
        return null;
      }
    },
    confidence() {
      const conf = this.collection.cardConfidence[this.card.id];
      return conf ? conf : 0;
    }
  },
  methods: {
    loadPage: function() {
      while (!this.card.alternatives) {
        /* Wait until alternatives are loaded*/
      }
      this.loaded = true;
    },
    bindCollection: function() {
      return this.$bind(
        "collection",
        db
          .collection("users")
          .doc(this.user.uid)
          .collection("collections")
          .doc(this.colId),
        { maxRefDepth: 1 }
      );
    },
    bindCard: function() {
      return this.$bind("card", db.collection("cards").doc(this.cardId));
    },
    getRating: function(alt) {
      try {
        return alt["upvoters"].length;
      } catch {
        return 0;
      }
    },
    backClick() {
      if (
        this.card &&
        this.card.alternatives &&
        this.card.alternatives.length === 0
      ) {
        this.dialog = true;
      } else {
        router.back();
      }
    },
    goBack() {
      this.dialog = false;
      router.back();
    }
  }
};
</script>
